import React from 'react';
import {connectToStore} from './Provider';

const ProductVideoReviewPromo = ({
	title,
	subtitle,
	description,
	videoSubtitle,
	videoDescription,
	posterImage,
	videoId,
	openVideoModal,
}) => (
	<div className="bg--gray-bg bb--gray-border">
		<div className="grid-container contained pt6 pb6 pt5--md pb5--md">
			<div className="row align--bottom">
				<div className="col c5--lg mb4 mb0--lg">
					<h3 className="sans--small fw--600 uppercase mb2">
						{subtitle}
					</h3>
					<h2 className="domaine--medium mb2">
						{title}
					</h2>
					<p className="color--gray-text">
						{description}
					</p>
				</div>

				<div className="col c1 show--lg" />

				<div className="col c6--md c3--lg mb3 mb0--md">
					<button
						title="Play"
						onClick={() => openVideoModal(videoId)}
						className="full-width pr video__poster"
						name="play">
						<span className="db image size--7x5">
							<picture>
								<source
									srcSet={`${posterImage}?w=1200&auto=format`}
									media="(min-width: 600px)"
								/>
								<img
									alt={title}
									src={`${posterImage}?w=800&auto=format`}
								/>
							</picture>
						</span>
						<span className="db video__poster__play medium" />
						<img
							className="db video__poster__icon medium"
							alt="play"
							src="/images/icon-play.svg"
						/>
					</button>
				</div>

				<div className="col c6--md c3--lg">
					<h2 className="domaine--medium mb2">
						{videoSubtitle}
					</h2>
					<p className="color--gray-text">
						{videoDescription}
					</p>
				</div>
			</div>
		</div>
	</div>
);


const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openVideoModal,
}) => ({
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(ProductVideoReviewPromo);